import React, { useState } from "react";

const TermsModal = ({ isOpen, onClose, mobile, countryCode }) => {
  if (!isOpen) return null;

  const terms = [
    {
      title: "1. Acceptance of Terms",
      content: `These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity ('you') and ${
        countryCode !== "IN" ? "Composz LLC" : "LIFE COLORS"
      }, a company registered in the State of ${
        countryCode !== "IN" ? "Delaware" : "Karanataka, India"
      } which owns and operates aiComposz.com ('Company', 'aiComposz', 'Composz', 'we', 'us', or 'our'), concerning your access to and use of this application. By accessing the application, you acknowledge that you have read, understood, and agreed to be bound by all of these Terms and Conditions. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS AND CONDITIONS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE APPLICATION AND YOU MUST DISCONTINUE USE IMMEDIATELY. DO NOT PURCHASE ANY IMAGE CREDITS IF YOU DO NOT AGREE TO THESE TERMS; ANY PURCHASED IMAGE CREDITS ARE NON-REFUNDABLE.`
    },
    {
      title: "2. User Eligibility & Authorization",
      content:
        "By using this application, you represent and warrant that you are of legal age in your jurisdiction and possess the legal authority to enter into these Terms and Conditions. Furthermore, you represent that you are fully authorized to use the payment method provided for any purchases made on this site."
    },
    {
      title: "3. User Content & Intellectual Property",
      content: [
        "You represent and warrant that you have full rights, titles, and interests in and to any images uploaded to the application.",
        "Generated Content: You own the rights to the images generated through the application. However, you grant aiComposz a perpetual, irrevocable license to use generated images for marketing, promotional purposes, and as reference material for service enhancement."
      ]
    },
    {
      title: "4. Absolute User Responsibility",
      content: [
        "aiComposz does not store user-uploaded images or images generated by the AI models. All data is processed in real-time and is not persisted on our servers.",
        "As such, before initiating image generation, you must ensure a stable and reliable internet connection to both send the request and receive the generated output.",
        "You must not close, refresh, or navigate away from the page once image generation has started. Doing so will result in the loss of the generated image.",
        "In the event of a connection loss or page refresh, image credits will still be deducted as the generation process was initiated. There are absolutely no refunds or credit reinstatements under these circumstances."
      ]
    },
    {
      title: "5. Acceptable Use Policy",
      content:
        "You agree to use the application only for lawful purposes. You are strictly prohibited from uploading or generating content that is obscene, nude, violent, aggressive, defamatory, or degrading to any individual, country, or religion. You must not use the tool to cause harm, harassment, or distress to any person or entity."
    },
    {
      title: "6. Nature of Service & AI Disclaimer",
      content: [
        "Composz LLC acts as an intermediary provider, utilizing Google Gemini AI Models to enhance images. We do not own or control the underlying AI models.",
        "No Guarantees: There is absolutely no guarantee regarding the quality, accuracy, or suitability of the generated output. AI models may produce unexpected, flawed, or inaccurate results.",
        "The service is provided on an 'AS IS' and 'AS AVAILABLE' basis. We do not warrant that the service will be uninterrupted, error-free, or free from defects."
      ]
    },
    {
      title: "7. Limitation of Liability",
      content: `To the maximum extent permitted by law, aiComposz, its officers, and employees shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the service, including but not limited to the non-generation of images or any output produced by the AI models. You agree not to bring any litigation or legal claims against ${
        countryCode !== "IN" ? "Composz LLC" : "LIFE COLORS"
      } under any circumstances.`
    },
    {
      title: "8. Payment & Refund Policy",
      content: [
        "All payments are final. There are absolutely no refunds once a payment is processed, including cases of unforeseen technical errors or model unavailability.",
        "In exceptional circumstances, users may submit a written request for a refund to 'team@aicomposz.com'. Such requests will be reviewed at our sole discretion, and submission does not guarantee a refund."
      ]
    },
    {
      title: "9. Third-Party Terms (Google Gemini)",
      content:
        "By using this application, you acknowledge that your uploaded images are processed by Google's servers. Your use of the service is subject to Google's Terms of Service and Privacy Policy. Composz LLC is not responsible for Google's data handling practices."
    },
    {
      title: "10. Data Privacy & Compliance",
      content:
        "We are committed to protecting your privacy in accordance with applicable laws, including the General Data Protection Regulation (GDPR) for EU residents, and the California Consumer Privacy Act (CCPA/CPRA) for California residents. We process data only as necessary to provide the service and do not sell your personal information to third parties."
    },
    {
      title: "11. Service Availability & Support",
      content: [
        "The application may not be available 24/7 and may experience periodic maintenance downtimes or service interruptions.",
        "Turnaround times for image generation are not guaranteed.",
        "This is a 'Do-It-Yourself' (DIY) application. We provide limited support and do not guarantee assistance if the application does not meet your specific expectations. Communications are conducted online only, and response times may be significantly delayed due to limited resources."
      ]
    },
    {
      title: "12. Governing Law & Jurisdiction",
      content: `These Terms shall be governed by and defined following the laws of the State of ${
        countryCode !== "IN"
          ? "Delaware, United States. Composz LLC"
          : "Karnataka, India. LIFE COLORS"
      } and yourself irrevocably consent that the courts of ${
        countryCode !== "IN" ? "Delaware" : "Karnataka"
      } shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.`
    }
  ];

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-2xl md:max-h-[85vh] md:rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-2xl md:max-h-[85vh] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        style={{ borderRadius: "3rem" }}
      >
        <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <h2 className="text-xl font-bold text-white tracking-tight">
            Terms & Conditions
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-full transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              // className="h-6 w-6 text-slate-400"
              className="w-6 md:h-8 md:w-8 text-slate-400 group-hover:text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* <div className="flex-1 overflow-y-auto p-6 md:p-8 space-y-6 text-sm text-slate-300 leading-relaxed"> */}
        <div
          className="flex-1 overflow-y-auto md:p-8 space-y-6 text-sm text-slate-300 leading-relaxed"
          style={{ display: "list-item", padding: "5%" }}
        >
          {terms.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h3 className="text-indigo-400 font-bold text-base">
                {section.title}
              </h3>
              {Array.isArray(section.content) ? (
                <ul className="list-disc pl-5 space-y-1">
                  {section.content.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p>{section.content}</p>
              )}
            </div>
          ))}
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
